var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-icon",class:_vm.active? 'active': ''},[_c('svg',{staticClass:"frame",attrs:{"viewBox":"0 0 100 100","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('frame-path',{ref:"frame"})],1)]),_c('div',{staticClass:"icon"},[_c('logo-image',{ref:"logoImage"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }